import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  FolderKanban,
  Receipt,
  UsersRound,
  ListChecks,
  History,
  Settings as SettingsIcon,
  Wallet,
  TrendingUp,
  HeartPulse,
  Layers,
  Gauge,
} from "lucide-react";
import { cn } from "@/lib/utils";
import { useAuth } from "@/lib/AuthContext";

const mainNav = [
  { to: "/dashboard/agency", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/dashboard/agency/clients", label: "Clients", icon: Users },
  { to: "/dashboard/agency/projects", label: "Projects", icon: FolderKanban },
  { to: "/dashboard/agency/invoices", label: "Invoices", icon: Receipt },
  { to: "/dashboard/agency/team", label: "Team", icon: UsersRound },
  { to: "/dashboard/agency/objective-templates", label: "Objective templates", icon: ListChecks },
  { to: "/dashboard/agency/audit-log", label: "Audit log", icon: History },
  { to: "/dashboard/agency/settings", label: "Settings", icon: SettingsIcon },
];

const businessNav = [
  { to: "/dashboard/agency/business/financials", label: "Financials", icon: Wallet },
  { to: "/dashboard/agency/business/sales-pipeline", label: "Sales & pipeline", icon: TrendingUp },
  { to: "/dashboard/agency/business/client-portfolio", label: "Client portfolio", icon: HeartPulse },
  { to: "/dashboard/agency/business/services", label: "Services", icon: Layers },
  { to: "/dashboard/agency/business/ceo-dashboard", label: "CEO dashboard", icon: Gauge },
];

function NavItem({ to, label, icon: Icon, end }) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        cn(
          "flex items-center gap-2.5 px-3 py-2 text-sm rounded-r-lg border-l-2 transition-colors",
          isActive
            ? "bg-accent text-foreground font-medium border-l-primary"
            : "text-muted-foreground border-l-transparent hover:bg-accent/60"
        )
      }
    >
      <Icon className="w-4 h-4 shrink-0" />
      {label}
    </NavLink>
  );
}

export default function AgencyLayout() {
  const { profile, signOut } = useAuth();

  return (
    <div className="grid grid-cols-[240px_1fr] min-h-screen bg-background text-foreground">
      <aside className="border-r border-border bg-card px-4 py-6 flex flex-col">
        <div className="px-2 pb-6">
          <div className="font-bold text-base tracking-tight">Agency dashboard</div>
          <div className="font-mono text-[11px] uppercase tracking-wide text-muted-foreground mt-0.5">
            abhinavjoshi.com
          </div>
        </div>

        <nav className="flex flex-col gap-0.5">
          {mainNav.map((item) => (
            <NavItem key={item.to} {...item} />
          ))}
        </nav>

        <div className="font-mono text-[10.5px] uppercase tracking-wide text-muted-foreground px-3 pt-4 pb-1.5">
          Agency business
        </div>
        <nav className="flex flex-col gap-0.5">
          {businessNav.map((item) => (
            <NavItem key={item.to} {...item} />
          ))}
        </nav>

        <div className="mt-auto pt-3 border-t border-border font-mono text-xs text-muted-foreground flex items-center justify-between">
          <span>{profile?.full_name || profile?.email}</span>
          <button onClick={signOut} className="underline hover:text-foreground">
            Sign out
          </button>
        </div>
      </aside>

      <main className="p-8">
        <Outlet />
      </main>
    </div>
  );
}
